import React from "react";

const DownloadItems = ({ svg, label, handleClick, width, minWidth }) => {
    return (
        <>
            <div className="download-wrapper">
                <div className="top-right-item polling" onClick={handleClick} style={{ width: width, minWidth: minWidth }}>
                    { svg }
                    { label }
                </div>
            </div>
        </>
    );
}

export default DownloadItems;